function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { Layout } from "../../components/Layout";
import { Main } from "../../components/Main/Main";
var displayStyleToTitle = {
    grid: "siatka",
    list: "lista"
};
function HomePage(props) {
    return /*#__PURE__*/ _jsx(Layout, {
        title: "Polski Frontend \u2013 ".concat(displayStyleToTitle[props.displayStyle], " artyku\u0142\xf3w z polskich blog\xf3w frontendowych"),
        titleTemplate: "",
        children: /*#__PURE__*/ _jsx(Main, _objectSpread({}, props))
    });
}
export var __N_SSG = true;
export default _withSuperJSONPage(HomePage);
